/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

export enum FeatureFlag {
  LMS_SKILLS = 'lms_skills',
  AI_ASSISTANT = 'ai_assistant',
  EDITOR_JS = 'editor_js',
  TIPTAP_EDITOR_V3 = 'tiptap_editor_v3',
  PROFILE_CERTS = 'profile_certs',
  V3_CERTIFICATES = 'v3_certificates',
  V3_COMMUNITY = 'v3_community',
  ENROLLMENT = 'enrollment',
  EMAIL_NOTIFICATIONS = 'email_notifications',
  PAGE_ANALYTICS = 'page_analytics',
  CATEGORIES = 'categories',
  EVENTS_TOP_BAR_HIDDEN = 'events_top_bar_hidden',
  TABLEAU_V2_ENABLED = 'tableau_v2_enabled',
  LMS_COURSE_BADGES = 'course_badges',
  LMS_DEEP_LINKING_NEW_VIEW = 'deeplinking_new_view',
  HELP_CENTER = 'help_center',
  EDITOR_JS_FORCE = 'editor_js_force',
  SCORM = 'scorm',
  MENTORS = 'mentors',
  INDEPENDENT_BADGES = 'independent_badges',
  FEEDBACK_360 = '360_feedback',
  ALLOW_RECORDING = 'allow_recording',
  PLAYLIST_COST = 'playlist_cost',
  FORCE_TWO_FACTOR_AUTHENTICATION = 'force_two_factor_authentication',
  NEW_WORKBOOK_REVIEW_UI = 'new_workbook_review_ui',
  AI = 'ai',
  AI_LER_EXP_GEN = 'ai_ler_exp_gen',
  AI_TEXT_ANALYSIS = 'ai_text_analysis',
  DOCUMENT_ANNOTATIONS = 'document_annotations',
  GOOGLE_CALENDAR_INTEGRATION = 'google_calendar_integration',
  OUTLOOK_INTEGRATION = 'outlook_integration',
  CANVAS_COURSES_ANALYTICS = 'canvas_courses_analytics',
  NEW_PROJECT_DOWNLOAD = 'new_project_download',
  ANALYTICS_DASHBOARDS = 'analytics_dashboards',
  PLAYLIST_ANALYTICS_DASHBOARDS = 'playlist_analytics_dashboards',
  COURSE_SETUP_DEV_PREVIEW = 'course_setup_dev_preview',
  MAGIC_LINK = 'magic_link',
  MESSAGE_BUTTON_ON_MENTEE_PROFILE = 'message_button_on_mentee_profile',
  LMS_ASSIGNMENT_DEEPLINK = 'lms_assignment_deeplink',
  ASSIGNMENTS = 'assignments',
  LTI_ASSIGNMENTS = 'lti_assignments',
  ASSIGNMENT_SHARING = 'assignment_sharing',
  FORM_CAH_SUBJECT = 'form_cah_subject',
  SHOW_PEERS_TO_LEARNER = 'show_peers_to_learner',
  SHOW_SUBMISSIONS_AND_PROGRESS_TO_LEARNER = 'show_submissions_and_progress_to_learner',
  MEMBERS_RE_INDEX_BUTTON = 'members_re_index_button',
}
